import { cn } from "lib/utils";
import styles from "./helper-text.module.css";

type HelperTextProps = {
  className?: string;
  children: React.ReactNode;
};

const HelperText = ({ className, children }: HelperTextProps) => {
  return <span className={cn(styles.helperText, className)}>{children}</span>;
};

export default HelperText;
